import axios from '@axios'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useProgramFeesSetting() {
  // Use toast
  const toast = useToast()
  // Table Handlers
  const tableColumns = [
    { key: 'name', label: 'Fees Name', sortable: false },
    { key: 'cost', label: 'Cost', sortable: false },
    { key: 'actions' },
  ]

  const fetchFees = queryParams => axios
    .get('/auth/fees', {
      params: queryParams,
    })
    .then(response => response.data.data)
    .catch(error => {
      const { response } = error
      toast({
        component: ToastificationContent,
        props: {
          title: 'Error fetching data',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
      return response.status
    })

  const postFee = queryParams => axios
    .post('/auth/fees', queryParams)
    .then(response => {
      toast({
        component: ToastificationContent,
        props: {
          title: 'New Fee was successfully created',
          icon: 'ThumbsUpIcon',
          variant: 'info',
        },
      })
      return response.data.data
    })
    .catch(error => {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Error creating Fee',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
      return error
    })

  const updFee = queryParams => axios
    .put(`/auth/fees/${queryParams.id}`, queryParams)
    .then(response => {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Fee was successfully updated',
          icon: 'ThumbsUpIcon',
          variant: 'info',
        },
      })
      return response.data.data.id
    })
    .catch(error => {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Error updating Fee',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
      return error.response
    })

  const deleteFee = id => axios
    .delete(`/auth/fees/${id}`)
    .then(() => {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Fee was successfully deleted',
          icon: 'ThumbsUpIcon',
          variant: 'info',
        },
      })
    })
    .catch(() => toast({
      component: ToastificationContent,
      props: {
        title: 'Error deleting fee',
        icon: 'AlertTriangleIcon',
        variant: 'danger',
      },
    }))

  const applyFee = queryParams => axios
    .post('auth/fees/apply-fee', queryParams)
    .then(response => {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Fee was successfully applied',
          icon: 'ThumbsUpIcon',
          variant: 'info',
        },
      })
      return response.data.data
    })
    .catch(error => {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Error applying Fee',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
      return error
    })

  const fetchGroupsForSelect = queryParams => axios
    .get('/auth/groups-for-select', {
      params: queryParams,
    })
    .then(response => response.data.data)
    .catch(error => {
      const { response } = error
      toast({
        component: ToastificationContent,
        props: {
          title: 'Error fetching groups',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
      return response.status
    })
  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  return {
    tableColumns,
    fetchFees,
    postFee,
    updFee,
    deleteFee,
    applyFee,
    fetchGroupsForSelect,
  }
}
